import React from 'react'
import { NavLink } from 'react-router-dom';
import './Navbar/NavBar.css'
import HomeIcons from './HomeIcons';
import classNames from 'classnames';

export default function DropDownUser({userData="" , list ,classname,classParentList ,classList='' ,navBar,classIcon}) {
  return (
    <div className={classNames('  w-11/12 p-5 gap-y-5 rounded-2xl justify-center mt-5 flex flex-col ',classname)}>
       {userData}
       <ul className={classNames('flex flex-col text-lg font-semibold font-sans ',classParentList)}>
        { list && list.map((element) =><NavLink key={element.key} to={element.link} onClick={element.logoutBtnClick} className={({isActive}) =>{
              return (isActive && navBar ? "bg-opacity-70 bgAuth rounded-lg py-[10px] px-[10px] block sm:mx-2 sm:py-0  w-full sm:w-[120px]" : `md:hover:bg-opacity-70 md:hover:bg-[#d0edfd]   rounded-md  duration-300 py-[5px] md:px-[8px]   md:py-0 md:mx-2`)
   }}><li className= {classNames("text-left",classList)} >
            <HomeIcons icon={element.icon} classname={classNames(element.classname,classIcon)} />
            {element.name}</li></NavLink> )}
       </ul>
    </div>
  )
}
